import { render, staticRenderFns } from "./add-claim-note.component.vue?vue&type=template&id=af6a6852&"
import script from "./add-claim-note.component.vue?vue&type=script&lang=ts&"
export * from "./add-claim-note.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports